export default __webpack_public_path__ + "static/media/reports.7d088075.jpg";